import { useState, useCallback, useEffect, useLayoutEffect, useRef } from "react"
import { ALWAYSCOMPLETE } from "./constants"
import { logmine, upperFirstLetter, rafDelay } from "./utils"
import { useMotionValue } from "framer-motion"
import { mvSubscribe } from "./context"

export const setSource = (variation, v, catalogYear) => {
  let url = ""
  let param = ""
  switch (variation) {
    case "dial":
      url = "configurator/raw-dial-with-shadow"
      break
    case "bezel":
      url = "configurator/bezel-with-shadow"
      break
    case "bracelet":
      url = "bracelet-highlight-on-full-watch"
      break
    case "shadow":
      param = "&ch1=1380"
      url = "upright-c-shadow"
      break
    case "model":
      url = "upright-bba-with-shadow"
      break
    case "material":
      url = ""
      break
    case "roller":
    case "watch":
      url = "upright-c"
      break
    default:
      throw new Error("unknown variation")
  }

  return `/v7/dam/${catalogYear}/${url}/${v}.png?impolicy=v7-main-configurator${param}`
}

export const setPicture = src => {
  //  console.log('setPicture', src)
  return {
    sources: [{ src: src, width: "800px", height: "1180px" }],
  }
}

export const useImageLoader = (uid, ref, list, domdelay = 40, displaydelay = 40) => {
  //  logmine("CustomHook", "useImageLoader", list)
  //  logmine("CustomHook", "useImageLoader", ref)
  const readyRef = useRef([])
  const ready = useMotionValue(false)
  const tmRef = useRef(null)

  const end = useCallback(() => {
    clearTimeout(tmRef.current)
    tmRef.current = setTimeout(() => {
      ready.set(true)
    }, displaydelay)
  }, [])

  const onload = useCallback(e => {
    //    if (!readyRef.current.length) return
    const i = e.target.getAttribute("data-loadindex")
    //    logmine("CustomHook", uid, "useImageLoader", "onload", i)
    const index = readyRef.current.indexOf(i)
    if (!!~index) readyRef.current.splice(index, 1)
    //    e.target.removeAttribute("data-loadindex")
    //    logmine("CustomHook", uid, "useImageLoader", "onload readyRef.current", readyRef.current)
    if (!readyRef.current.length) end()
  }, [])

  useLayoutEffect(() => {
    //    logmine("useLayoutEffect", "useImageLoader", "list", list)
    if (!process.browser || !ref) return
    clearTimeout(tmRef.current)
    const { current: root } = ref
    if (!root) return
    ready.set(false)
    if (!list || !list.length) return

    rafDelay(() => {
      //        logmine("useLayoutEffect", "useImageLoader", "play list", list)
      readyRef.current = [...root.querySelectorAll("img")]
        .filter(el => (ALWAYSCOMPLETE && !el.width) || !el.complete)
        .map((el, i) => {
          el.setAttribute("data-loadindex", `${uid}_${i}`)
          return el
        })
        .map(el => el.getAttribute("data-loadindex"))

      if (!readyRef.current.length) {
        end()
      } else {
        root.addEventListener("load", onload, true)
        root.addEventListener("error", onload, true)
      }
    })

    return () => {
      root.removeEventListener("load", onload)
      root.removeEventListener("error", onload)
    }
  }, [list])

  return ready
}
/*
export const useData = (config, dict) => {
  const [ready, setReady] = useState(false)
  const [{ lang, codeLang, AEMdata, labels }] = useGlobalStateValue()

  useEffect(() => {
    if (!lang || !codeLang || !AEMdata || !labels || !Object.keys(labels).length) return
    config.set({
      lang: lang.toLowerCase(),
      codeLang: codeLang.toLowerCase(),
      imagesPath: AEMdata.watchesImagesUrl,
      folderPath: AEMdata.watchesImagesFolderPath || "/dam/2021",
      requestPath: AEMdata.filtersServiceUrl, //"https://search.rolex.com/solr/rolexcom",
      credentials: !!AEMdata.withCredentials,
      imagesUrl: AEMdata.imagesUrl,
    })
    dict.set(labels)
    setReady(true)
  }, [lang, codeLang, AEMdata, labels, config, dict])

  return ready
}
*/
export const useMediaLoader = (uid, ref, list, video = false, domdelay = 40, displaydelay = 300) => {
  //  logmine("CustomHook", "useImageLoader", list)
  //  logmine("CustomHook", "useImageLoader", ref)
  const readyRef = useRef([])
  const ready = useMotionValue(false)
  const tmRef = useRef(null)

  const end = useCallback(() => {
    //    logmine("Callback", "useMediaLoader", "end")
    clearTimeout(tmRef.current)
    tmRef.current = setTimeout(() => {
      ready.set(true)
    }, displaydelay)
  }, [ready, displaydelay])

  const onload = useCallback(
    e => {
      //    if (!readyRef.current.length) return
      const i = e.target.getAttribute("data-loadindex")
      //      logmine("CustomHook", uid, "useMediaLoader", "onload", i)
      //      logmine("CustomHook", uid, "useMediaLoader", "onload", e.target.currentSrc)
      const index = readyRef.current.indexOf(i)
      if (!!~index) readyRef.current.splice(index, 1)
      e.target.removeAttribute("data-loadindex")
      //      logmine("CustomHook", uid, "useMediaLoader", "onload readyRef.current", readyRef.current)
      if (!readyRef.current.length) end()
    },
    [uid, end]
  )

  useLayoutEffect(() => {
    //    logmine("useLayoutEffect", "useMediaLoader", "list", list)
    if (!process.browser || !ref) return
    clearTimeout(tmRef.current)
    const { current: root } = ref
    if (!root) return
    ready.set(false)
    if (!list || !list.length) return

    rafDelay(() => {
      //      logmine("useLayoutEffect", "useMediaLoader", "play list", list)
      readyRef.current = [...root.querySelectorAll("img")]
        .filter(el => (ALWAYSCOMPLETE && !el.width) || !el.complete)
        .concat(video ? [...root.querySelectorAll("video")] : [])
        .map((el, i) => {
          el.setAttribute("data-loadindex", `${uid}_${i}`)
          return el
        })
        .map(el => el.getAttribute("data-loadindex"))

      if (!readyRef.current.length) {
        end()
      } else {
        root.addEventListener("load", onload, true)
        root.addEventListener("error", onload, true)
        if (video) root.addEventListener("canplaythrough", onload, true)
      }
    })

    return () => {
      root.removeEventListener("load", onload, true)
      root.removeEventListener("error", onload, true)
      if (video) root.removeEventListener("canplaythrough", onload, true)
      //      logmine("useLayoutEffect", "useMediaLoader", "events cleared")
    }
  }, [list])

  return ready
}

export const useImageLoaderII = (uid, ref, list, domdelay = 40, displaydelay = 100) => {
  //  logmine("CustomHook", "useImageLoader", list)
  //  logmine("CustomHook", "useImageLoader", ref)
  const readyRef = useRef([])
  const [ready, setReady] = useState(false)
  const tmRef = useRef(null)

  const end = useCallback(() => {
    clearTimeout(tmRef.current)
    tmRef.current = setTimeout(() => {
      setReady(true)
    }, displaydelay)
  }, [displaydelay])

  const onload = useCallback(
    e => {
      //    if (!readyRef.current.length) return
      const i = e.target.getAttribute("data-loadindex")
      //      logmine("CustomHook", uid, "useImageLoader", "onload", i)
      const index = readyRef.current.indexOf(i)
      if (!!~index) readyRef.current.splice(index, 1)
      e.target.removeAttribute("data-loadindex")
      //      logmine("CustomHook", uid, "useImageLoader", "onload readyRef.current", readyRef.current)
      if (!readyRef.current.length) end()
    },
    [uid, end]
  )

  useLayoutEffect(() => {
    //    logmine("useLayoutEffect", "useImageLoader", "list", list)
    if (!process.browser || !ref) return
    clearTimeout(tmRef.current)
    const { current: root } = ref
    if (!root) return
    setReady(false)
    if (!list || !list.length) return

    let tm = setTimeout(() => {
      //        logmine("useLayoutEffect", "useImageLoader", "play list", list)
      readyRef.current = [...root.querySelectorAll("img")]
        .filter(el => el.parentNode.parentNode.className.indexOf("image-fallback") < 0)
        .filter(el => (ALWAYSCOMPLETE && !el.width) || !el.complete)
        .map((el, i) => {
          el.setAttribute("data-loadindex", `${uid}_${i}`)
          return el
        })
        .map(el => el.getAttribute("data-loadindex"))

      if (!readyRef.current.length) {
        end()
      } else {
        root.addEventListener("load", onload, true)
        root.addEventListener("error", onload, true)
      }
    }, domdelay)

    return () => {
      clearTimeout(tm)
      root.removeEventListener("load", onload)
      root.removeEventListener("error", onload)
    }
  }, [uid, ref, list, domdelay, onload, end])

  return ready
}

export const useActive = wactive => {
  //  logmine("CustomHook", "useActive", wactive)
  const [viewlink, setViewlink] = useState("#")

  const update = useCallback(v => {
    if (!v) return
    setViewlink(v.specs[8])
  }, [])

  useEffect(() => mvSubscribe("Hooks useActive", wactive, update), [wactive, update])

  return viewlink
}
